import { useState } from "react";
import { Label } from "../../ui/label";
import { Input } from "../../ui/input";
import { Button } from "../../ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../ui/select";
import AdvancedSection from "./AdvancedSection";
import { Plus, X } from "lucide-react";

export default function PrecioAtributosConfig({ config, onChange }) {
  const [nuevo, setNuevo] = useState({ campo: "", op: "eq" });
  const attrs = config?.precioBase?.atributosParametros || {};

  const setAttrs = (next) => onChange("precioBase.atributosParametros", next);
  const agregar = () => {
    const campo = nuevo.campo.trim();
    if (!campo || attrs[campo]) return;
    setAttrs({ ...attrs, [campo]: nuevo.op });
    setNuevo({ campo: "", op: "eq" });
  };
  const eliminar = (campo) => {
    const next = { ...attrs };
    delete next[campo];
    setAttrs(next);
  };

  return (
    <div className="space-y-4">
      <div>
        <p className="text-sm font-medium text-gray-800 mb-1">Atributos que discriminan el precio</p>
        <p className="text-xs text-gray-500 mb-3">Ej: comuna (eq), especialidades (array_contains). El precio se busca en la tabla según estos atributos del asegurado.</p>
        <div className="space-y-2">
          {Object.entries(attrs).map(([campo, op]) => (
            <div key={campo} className="flex items-center gap-2 bg-blue-50 border border-blue-200 rounded px-3 py-2">
              <span className="text-sm font-medium">{campo}</span>
              <Select value={op} onValueChange={(v) => setAttrs({ ...attrs, [campo]: v })}>
                <SelectTrigger className="h-8 w-44 text-sm"><SelectValue /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="eq">Igual (eq)</SelectItem>
                  <SelectItem value="array_contains">Contiene (array_contains)</SelectItem>
                </SelectContent>
              </Select>
              <button type="button" onClick={() => eliminar(campo)} className="ml-auto text-gray-400 hover:text-red-500"><X className="h-4 w-4" /></button>
            </div>
          ))}
          {Object.keys(attrs).length === 0 && <p className="text-sm text-gray-400 italic">Sin atributos configurados.</p>}
        </div>
        <div className="flex gap-2 mt-3">
          <Input value={nuevo.campo} onChange={(e) => setNuevo((p) => ({ ...p, campo: e.target.value }))} placeholder="campo (ej: comuna)" className="h-8 text-sm w-48" onKeyDown={(e) => e.key === "Enter" && (e.preventDefault(), agregar())} />
          <Select value={nuevo.op} onValueChange={(v) => setNuevo((p) => ({ ...p, op: v }))}>
            <SelectTrigger className="h-8 w-44 text-sm"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="eq">Igual (eq)</SelectItem>
              <SelectItem value="array_contains">Contiene (array_contains)</SelectItem>
            </SelectContent>
          </Select>
          <Button type="button" variant="outline" size="sm" onClick={agregar}><Plus className="h-4 w-4" /></Button>
        </div>
      </div>

      <AdvancedSection>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <Label className="text-xs text-gray-500">Precio base — Tabla</Label>
            <Input value={config?.precioBase?.tabla || ""} onChange={(e) => onChange("precioBase.tabla", e.target.value)} placeholder="precios_base" />
          </div>
          <div>
            <Label className="text-xs text-gray-500">Precio base — Campo Resultado</Label>
            <Input value={config?.precioBase?.campoResultado || ""} onChange={(e) => onChange("precioBase.campoResultado", e.target.value)} placeholder="precio_uf" />
          </div>
        </div>
      </AdvancedSection>
    </div>
  );
}
